import {
  Identifiable,
  Document,
  ProjectExpenseType,
  projectExpenseType,
} from "@planzone/dto";
import { id } from "./id";

type ProjectExpense = {
  uuid: string;
  expenseType: Identifiable<ProjectExpenseType>;
  actualDate: string;
  attachments: Identifiable<Document>[];
  name: string;
  orderNumber: string;
  plannedDate: string;
  createdDate: string;
  quantity: number;
  unitAmount: string;
};

const projectExpense: ProjectExpense = {
  uuid: id,
  expenseType: { ...projectExpenseType, uuid: id },
  actualDate: "",
  name: "",
  attachments: [],
  orderNumber: "",
  plannedDate: "",
  createdDate: "",
  quantity: 0,
  unitAmount: "",
};

export type { ProjectExpense };

export { projectExpense };
